var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 15.5375V6.71123C3.33203 4.33289 3.33203 3.14372 4.06426 2.40487C4.7965 1.66602 5.97501 1.66602 8.33203 1.66602H11.6654C14.0224 1.66602 15.2009 1.66602 15.9331 2.40487C16.6654 3.14372 16.6654 4.33289 16.6654 6.71123V15.5375C16.6654 16.7973 16.6654 17.4271 16.2804 17.675C15.6513 18.0803 14.6788 17.2305 14.1896 16.9221C13.7854 16.6672 13.5834 16.5398 13.3591 16.5324C13.1168 16.5244 12.9111 16.6467 12.4744 16.9221L10.882 17.9263C10.4524 18.1972 10.2377 18.3327 9.9987 18.3327C9.7597 18.3327 9.54495 18.1972 9.11536 17.9263L7.52297 16.9221C7.11882 16.6672 6.91675 16.5398 6.69247 16.5324C6.45013 16.5244 6.24447 16.6467 5.80776 16.9221C5.31866 17.2305 4.34609 18.0803 3.71699 17.675C3.33203 17.4271 3.33203 16.7973 3.33203 15.5375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 10.834H6.66797",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33464 8.33398H6.66797",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 13.334H6.66797",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30609_1632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.66667C11.25 7.1269 11.6231 7.5 12.0833 7.5H12.9167C13.3769 7.5 13.75 7.1269 13.75 6.66667C13.75 6.20643 13.3769 5.83333 12.9167 5.83333H12.0833C11.6231 5.83333 11.25 5.46024 11.25 5C11.25 4.53976 11.6231 4.16667 12.0833 4.16667H12.9167C13.3769 4.16667 13.75 4.53976 13.75 5M12.5 3.75V7.91667",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30609_1632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "white",
    transform: "translate(10 3.33398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.6e95df86075f99fdc52871d2428d688e.svg";
export { ForwardRef as ReactComponent };